import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'form-control-feedback',
    templateUrl: './form-control-feedback.component.html',
    standalone: false
})
export class FormControlFeedbackComponent {
	@Input() field: UntypedFormControl;
	@Input() messages: any = {};
	@Input() isFullWidth: boolean = false;
}
